import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";

import {
  checkPauseResumeAvailable,
  createPauseResumeEnabledFn,
} from "./BfxBlotterOrdersContextMenuPauseItem";
import { OrderPauseState } from "shared/cubiq-services/model/orders/OrderPauseState";

export class BfxBlotterOrdersContextMenuResumeItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_RESUME,
      "Resume",
      checkPauseResumeAvailable,
      createPauseResumeEnabledFn(OrderPauseState.isResumableOrder),
      ContextMenuItemStateCommandCriteria.Item,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new ContextMenuItemState();
    this.state.title = oldState.title;
  }
}
